module.exports = __webpack_public_path__ + "static/media/CrossCircleIcon.dc0c6260.svg";